// Collections v2 supports. Crop-required ones work because a crop image hands
// off to the legacy cropperjs dialog (see _browseV2 in media_manager.js). The
// CartImage collections read the employee drawer rather than the per-user
// library, which library_surface.ts routes for them. Listed explicitly so
// adding a collection is a deliberate opt-in (see MediaFilters for the full
// set).
const V2_SUPPORTED_ACCEPTS = new Set([
   'wiki_media',
   'wiki_summary_image',
   // The site logo on Manage > Appearance and each collection's image.
   'site_image',
   'profile_image',
   'guide_main_image',
   'guide_step_image',
   // Object/video/embed/document collections need no crop support at all;
   // guide_step_object covers the guide intro video target too.
   'guide_step_object',
   'guide_step_video',
   'guide_step_embed',
   'guide_document',
   // The document a user or business submits on their Certifications page.
   'team_certification',
   // The admin drawer, served by /api/2.0/admin/product-images/library.
   // campaign_image is a drawer collection too, but nothing calls it and
   // nothing covers it, so it stays on v1 for now.
   'product_image',
]);

/** Whether Media Manager v2 can handle this filter collection (flag aside). */
export function acceptsSupportsMediaManagerV2(accepts: string): boolean {
   return V2_SUPPORTED_ACCEPTS.has(accepts);
}
